import { selectRankingFilterLanguageSettings } from "../balancingSelectors/selectBalancingLanguage";
import { IdModal } from "../features/modals/IdModal";
import { PlayerRankingCategory } from "../features/ranking/PlayerRankingCategory";
import { StatusCode } from "../utils/network/generated/protoTypes";
import { selectCoopName } from "./selectCoopInfo";
import { selectModalTabId } from "./selectModalTabId";
import { selectPlayerName } from "./selectPlayerInfo";
export var selectRankInfo = {};
export var selectRankEntry = function (state) {
    var type = selectModalTabId(state, IdModal.PlayerRanking);
    switch (type) {
        case PlayerRankingCategory.CoopLevelRanking:
            return state.playerRanking.coopXpHighScores.highScores;
        case PlayerRankingCategory.PlayerLevelRanking:
        default:
            return state.playerRanking.playerXpHighScores.highScores;
    }
};
export var selectSelfEntry = function (state) {
    var type = selectModalTabId(state, IdModal.PlayerRanking);
    switch (type) {
        case PlayerRankingCategory.CoopLevelRanking:
            return state.playerRanking.coopXpHighScores.selfScore;
        case PlayerRankingCategory.PlayerLevelRanking:
        default:
            return state.playerRanking.playerXpHighScores.selfScore;
    }
};
export var selectRankingNameSearchErrorExists = function (state) {
    return state.errors.TextErrors.indexOf(StatusCode.NAME_INVALID) > -1;
};
export var selectRankingSelectedLanguage = function (state) {
    var language = selectRankingFilterLanguageSettings();
    var selectedLanguage = state.playerRanking.selectedLanguage;
    if (selectedLanguage) {
        return language.find(function (lang) { return lang.languageCode === selectedLanguage.languageCode; });
    }
    return language[0];
};
export var selectRankingCurrentPosition = function (state) {
    var type = selectModalTabId(state, IdModal.PlayerRanking);
    switch (type) {
        case PlayerRankingCategory.CoopLevelRanking:
            return state.playerRanking.coopXpHighScores.currentPosition || 1;
        case PlayerRankingCategory.PlayerLevelRanking:
        default:
            return state.playerRanking.playerXpHighScores.currentPosition || 1;
    }
};
export var selectRankingSelfName = function (state) {
    var type = selectModalTabId(state, IdModal.PlayerRanking);
    switch (type) {
        case PlayerRankingCategory.CoopLevelRanking:
            return selectCoopName(state);
        case PlayerRankingCategory.PlayerLevelRanking:
        default:
            return selectPlayerName(state).name;
    }
};
export var selectRankingIsLastPosition = function (state) {
    var type = selectModalTabId(state, IdModal.PlayerRanking);
    switch (type) {
        case PlayerRankingCategory.CoopLevelRanking:
            return selectRankEntry(state).length < 10;
        case PlayerRankingCategory.PlayerLevelRanking:
        default:
            return selectRankEntry(state).length < 10;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectRankInfo.ts
// module id = 220
// module chunks = 3